import { animate, style, transition, trigger } from '@angular/animations';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { fromEvent, merge, Observable } from 'rxjs';
import { tab } from 'src/app/forms/formview/editform.component';
import { CustomTab } from 'src/app/interfaces/custom-tab';
import { TabColumns } from 'src/app/interfaces/tabcolumns';
import { DialogService } from 'src/app/services/dialog.service';
import { FormConfigurationTabSelectComponent } from './form-configuration-tab-select/form-configuration-tab-select.component';

export interface tabcontrol{
    tabname:string;
    editing:boolean;
}

@Component({
    selector: 'form-configuration',
    templateUrl: './form-configuration.component.html',
    styleUrls: ['./form-configuration.component.scss'],
    animations: [
        trigger('enterAnimation', [
            transition(':enter', [
                style({ transform: 'translateX(-100%)', opacity: 0 }),
                animate('500ms', style({ transform: 'translateX(0)', opacity: 1 }))
            ]),
            transition(':leave', [
                style({ transform: 'translateX(0)', opacity: 1 }),
                animate('500ms', style({ transform: 'translateX(-100%)', opacity: 0 }))
            ])
        ])
    ],
    standalone: false
})
export class FormConfigurationComponent implements OnInit, OnChanges {


  
  @Input('tab') tab:tab[];
  @Input('customtab') customtab:CustomTab[]
  
  @Input() savingEvent: Observable<boolean>;
  selectAll:boolean = false;
  constructor(private dialog:DialogService, private cd:ChangeDetectorRef ) { }
  
  getDynamic(item:tab) {
      return item.dynamic;
  }

  ngOnChanges(changes: SimpleChanges): void {
     if ( changes.tab.currentValue ){
          changes.tab.currentValue.forEach(d=>{
              let index = this.connected.findIndex(x=>x == d.customName );
              if ( index == -1){
                  this.connected.push(d.customName);
              }
          })
     }
  }

  @Input('visibleColumns') visibleColumns:TabColumns[]=[];
  @Input('nonVisibleColumns') nonVisibleColumns:TabColumns[]=[];
  @Output('changing')changing:EventEmitter<boolean> = new EventEmitter<boolean>();
  connected =['Disponivel'];
  editingTitle = false;
  preventSingleClick = false;
  timer;
  //editControl:tabcontrol[] = [];
  enableTrash = false;  
  enableDrag = true;

  ngOnInit(): void {
    if ( this.visibleColumns == null ){
      this.visibleColumns = [];
    }

    this.tab.forEach(x=>{
      this.connected.push(x.customName);
    });
    
    if ( this.savingEvent != null ){
      this.savingEvent.subscribe(salvando=>{
        if ( salvando ){
            this.changing.next(true);
        }
      })
    }
    
    if ( this.visibleColumns != null ){
      this.visibleColumns.forEach(data=>{
        if ( data.columnName.indexOf('->') >-1 ){
          data.noShow = true;
        }else{
          data.noShow = false;
        }
      });
    

      const toRemove  = this.visibleColumns.filter(d=>{
          if( this.tab.findIndex(x=>x.customName == d.tabName)==-1 ){
            return true;
          }else{
            return false;
          }
      });

      toRemove.forEach(d=>{
        d.tabName = "Disponivel";
        d.visible  =false;
        let index = this.visibleColumns.findIndex(z=>z.columnName==z.columnName);
        this.visibleColumns.splice(index,1);
        this.nonVisibleColumns.push(d);
      });
  
      this.visibleColumns.sort((a,b)=>{
      
        if (a.columnName > b.columnName  ) return 1;
        if (a.columnName < b.columnName  ) return -1;
        return 0;
      });
    }
    
    
    // this.visibleColumns  = this.visibleColumns.filter(d=>{
    //   if( this.tab.findIndex(x=>x.customName == d.tabName)>-1 ){
    //     return true;
    //   }else{
    //     return false;
    //   }
    // });
  
    


    if ( this.nonVisibleColumns != null ){

      this.nonVisibleColumns.forEach(data=>{
          data.visible = false;
          if ( data.columnName.indexOf('->') >-1){
            data.noShow = true;
          }else{
            data.noShow = false;
          }
      })

      

      this.nonVisibleColumns.sort((a,b)=>{
        
        if (a.columnName > b.columnName  ) return 1;
        if (a.columnName < b.columnName  ) return -1;
        return 0;
        
      });
    }

    
    
    
  }

  titleClick(desctab:string,event:Event){
    
    event.preventDefault();
    event.stopImmediatePropagation();
    
    this.preventSingleClick = false;
    const delay = 200;
    this.timer = setTimeout(() => {
        if (!this.preventSingleClick) {
           if ( this.editingTitle ){
             event.preventDefault();
             event.stopImmediatePropagation();
           }  
        }
    }, delay);
  }

  saveNewName(desctab:tab, newvalue:string){
      const oldName = desctab.customName;
      this.visibleColumns.forEach(x=>{
          if ( x.tabName == oldName ){
            x.tabName = newvalue;
          }
      });

      this.visibleColumns.forEach(x=>{
          if ( x.tabName == oldName ){
            //x.tabName = newvalue;
            /*let data = {tabName:newvalue, columnName: x.columnName};
            this.changing.next( {
              visibleColumns: this.visibleColumns,
              nonVisibleColumns: this.nonVisibleColumns,
              data: data
            });*/
          }
      });

      this.tab.forEach(function(part, index) {
        if ( part.customName == oldName){
          this[index].customName = newvalue;
        }
      }, this.tab)

      this.customtab.forEach(x=>{
        if ( x.desctab == oldName){
          x.desctab = newvalue;
        }
      });
      

      // bug antigo: usava 'nonVisible' (nome de template ref), mas o id real da
      // lista de disponíveis é 'Disponivel' — após renomear uma aba o drag quebrava
      this.connected =['Disponivel'];
      this.tab.forEach(x=>{
        this.connected.push(x.customName);
      });
      let newTab = this.tab.find(d=>d.customName==newvalue);
      this.getEditControl(newTab).editing = false;
      
  }

  titleDbClick(desctab:tab,event:Event){
    
    event.preventDefault();
    event.stopImmediatePropagation();
    this.preventSingleClick = true;
    clearTimeout(this.timer);
    this.getEditControl(desctab).editing = true;
  }

  removeAba(tab:tab){
      
      if ( this.visibleColumns.filter(d=>d.tabName == tab.customName).length > 0 ){
        throw Error("Não é permitido excluir abas/etapas com campos.");
      }else{
        
        let index = this.tab.findIndex(d=>d.customName==tab.customName);
        
        this.tab.splice(index,1);

        let indexct = this.customtab.findIndex(d=>d.desctab==tab.customName);
        this.customtab.splice(indexct,1);

      }
  }

  getEditControl(desctab:tab):CustomTab{
      let data = this.customtab.find(x=>x.desctab == desctab.customName);
      if ( data ){
        return data;
      }else{
        let ob =    { 
            desctab: desctab.customName,
            editing: false,
            options: null,
            isFk:true,
            active: true,
            originalName: desctab.originalName
          }
          this.customtab.push(ob);
        return ob;
      }
  }

  drop(event: CdkDragDrop<TabColumns[]>) {
     
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {

        let tabName = event.previousContainer.id;
        let prev:TabColumns =  event.previousContainer.data.filter(x=>x.tabName == tabName)[event.previousIndex];
    
        
        if ( event.previousContainer.id != "Disponivel"){
          
          try{
            let ind:number = this.visibleColumns.findIndex(x=>x.tabName == prev.tabName && x.columnName == prev.columnName );
            this.visibleColumns.splice(ind,1);
          }catch(Exception){
            let ind2:number = this.visibleColumns.findIndex(x=>x.columnName == prev.columnName );
            if ( ind2 > -1 ){
              this.visibleColumns.splice(ind2,1);
            }
          }
          
          
          prev.tabName = "Disponivel";
          prev.visible  =false;
          this.nonVisibleColumns.push(prev);
  
        }else{
          
          let ind:number = this.nonVisibleColumns.findIndex(x=>x.tabName == prev.tabName && x.columnName == prev.columnName );
          
          this.nonVisibleColumns.splice(ind,1);
          prev.tabName = event.container.id == 'cdk-drop-list-1' ? 'Geral' : event.container.id;
          prev.checked = false;
          prev.visible = true;
          this.visibleColumns.push(prev);
        }
      
    }
  }


  moveSelected(){
      
      let list = this.nonVisibleColumns.filter(fil=>{return fil.checked});
      if ( list.length > 0 ){
          
          let unique:string[] = this.customtab.filter(d=>d.isFk==false || d.isFk==null).map(d=>d.desctab);
          unique.sort((a,b)=>{
              
            if (a > b  ) return 1;
            if (a < b  ) return -1;
            return 0;
            
          });
          
          
          this.dialog.openGenericDialog(FormConfigurationTabSelectComponent,unique,(valor)=>{
              if ( valor != null ){
                
                list.forEach(n=>{
                  let ind:number = this.nonVisibleColumns.findIndex(x=>x.tabName == n.tabName && x.columnName == n.columnName );
                  this.nonVisibleColumns.splice(ind,1);
                  n.tabName = valor;
                  n.checked = false;
                  this.visibleColumns.push(n);
                });

                this.cd.detectChanges();
              }
          })
      }
  }

  changeAcess(event, item){
      
  }

  

  checkItem(checked: boolean, item:TabColumns){
    item.checked = checked === true;
  }

   ngOnDestroy(){
     
   }

   dropAccordion(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.tab, event.previousIndex, event.currentIndex);
  }

  dragOn(item){
    return this.enableDrag;
  }

  checkAll(checked: boolean){
    this.selectAll = checked === true;
    this.nonVisibleColumns.map(x=>{
        x.checked = this.selectAll;
        return x;
      } );
  }

  onKeyDownEdit(event:KeyboardEvent){
      event.stopPropagation();
      event.stopImmediatePropagation();
  }

  canReturnFkName(item:tab){
      if ( item.customName != item.originalName ){
        return true;
      }else{
        return false;
      }
  }

  returnOriginalValue(item:tab, event:Event){
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    this.saveNewName(item,item.originalName)
  }

  cancelEdit(item:tab,event:Event){
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    this.getEditControl(item).editing=false;
  }

  changeToggle(event:Event){
    event.stopPropagation();
    event.stopImmediatePropagation();
    
  }
}
